<div id="achSourceOfFunds">
  <a
    *ngIf="enableUseSloaContainer"
    class="saManageAccountsLink"
    [ngClass]="isAchIn ? 'achInSaManageAccountsLink' : 'achOutSaManageAccountsLink'"
    (click)="actionCenterRedirect()"
  >Add or manage accounts</a>
  <mm-standing-authorization-card-container
    *ngIf="enableUseSloaContainer; else legacyAchStandingAuthControl"
    [label]="isAchIn ? 'Source of funds' : 'Account to receive funds'"
    [authorizationCount]="standingAuthCards.length"
    [cards]="standingAuthCards"
    (cardSelected)="onStandingAuthCardSelected($event)">
  </mm-standing-authorization-card-container>
  <ng-template #legacyAchStandingAuthControl>
    <mm-card-component [parentForm]="parentForm" [cardModel]="cardModel"></mm-card-component>
    <a [ngClass]="isAchIn ? 'achIn' : 'achOut'" (click)="actionCenterRedirect()">Add or manage accounts</a>
  </ng-template>
</div>
